var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.75h-2v-2a.75.75 0 00-1.5 0v2h-2a.75.75 0 000 1.5h2v2a.75.75 0 001.5 0v-2h2a.75.75 0 000-1.5z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3IiBoZWlnaHQ9IjciIHZpZXdCb3g9IjAgMCA3IDciPgogIDxwYXRoIGQ9Ik02LjI1LDIuNzVoLTJ2LTJhLjc1Ljc1LDAsMCwwLTEuNSwwdjJoLTJhLjc1Ljc1LDAsMCwwLDAsMS41aDJ2MmEuNzUuNzUsMCwwLDAsMS41LDB2LTJoMmEuNzUuNzUsMCwwLDAsMC0xLjVaIi8+Cjwvc3ZnPgo=";
export { SvgSmallPlus as ReactComponent };